'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'compact-disc';
var width = 512;
var height = 512;
var aliases = [128191,128192,128440];
var unicode = 'f51f';
var svgPathData = ['M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zm56 0C72 154.4 154.4 72 256 72c4.4 0 8 3.6 8 8s-3.6 8-8 8C163.2 88 88 163.2 88 256c0 4.4-3.6 8-8 8s-8-3.6-8-8zm280 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z', 'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm336 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm80 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM88 256c0 4.4-3.6 8-8 8s-8-3.6-8-8C72 154.4 154.4 72 256 72c4.4 0 8 3.6 8 8s-3.6 8-8 8C163.2 88 88 163.2 88 256z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompactDisc = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;